import { O as OramaChatButton$1, d as defineCustomElement$1 } from './p-4ca3bdb7.js';
const OramaChatButton = OramaChatButton$1;
const defineCustomElement = defineCustomElement$1;
export { OramaChatButton, defineCustomElement }; //# sourceMappingURL=orama-chat-button.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JhbWEtY2hhdC1idXR0b24uanMiLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9